import amplitude from "amplitude-js";
import { constantCase } from "change-case";
export var MANAGE_GROUP_ADD_GROUP = "MANAGE_GROUP_ADD_GROUP";
export var MANAGE_GROUP_DELETE_GROUP = "MANAGE_GROUP_DELETE_GROUP";
export var MANAGE_GROUP_RENAME_GROUP = "MANAGE_GROUP_RENAME_GROUP";
export var MANAGE_GROUP_ADD_USER = "MANAGE_GROUP_ADD_USER";
export var MANAGE_GROUP_REMOVE_USER = "MANAGE_GROUP_REMOVE_USER";
export var MANAGE_GROUP_MODAL_CLOSED = "MANAGE_GROUP_MODAL_CLOSED";
export var MANAGE_ROLE_ADD_ROLE = "MANAGE_ROLE_ADD_ROLE";
export var MANAGE_ROLE_RENAME_ROLE = "MANAGE_ROLE_RENAME_ROLE";
export var MANAGE_ROLE_DELETE_ROLE = "MANAGE_ROLE_DELETE_ROLE";
export var MANAGE_ROLE_CHANGE_PERMISSION = "MANAGE_ROLE_CHANGE_PERMISSION";
export var MANAGE_ROLE_ADD_USER = "MANAGE_ROLE_ADD_USER";
export var MANAGE_ROLE_REMOVE_USER = "MANAGE_ROLE_REMOVE_USER";
export var MANAGE_ROLE_MODAL_CLOSED = "MANAGE_ROLE_MODAL_CLOSED";
export var SYSTEM_SETTINGS_UPDATE = "SYSTEM_SETTINGS_UPDATE";
export var USER_LIST_SORT = "USER_LIST_SORT";
export var USER_LIST_FILTER = " USER_LIST_FILTER";
export var USER_LIST_CUSTOMIZE = "USER_LIST_CUSTOMIZE";
export var USER_LIST_SEARCH = "USER_LIST_SEARCH";
export var USER_LIST_STATUS_CHANGE = "USER_LIST_STATUS_CHANGE";
export var USER_LIST_ROLE_CHANGE = "USER_LIST_ROLE_CHANGE";
export var USER_LIST_UPDATE_USER = "USER_LIST_UPDATE_USER";
export var USER_LIST_EXPORT = "USER_LIST_EXPORT";
export var USER_LIST_MANAGE_ROLE_PERMISSIONS = "USER_LIST_MANAGE_ROLE_PERMISSIONS";
export var USER_LIST_ONCLICK_USERNAME = "USER_LIST_ONCLICK_USERNAME";
export var manageGroupAddGroup = function (value) {
    amplitude.logEvent(MANAGE_GROUP_ADD_GROUP, {
        value: value
    });
};
export var manageGroupDeleteGroup = function (value) {
    amplitude.logEvent(MANAGE_GROUP_DELETE_GROUP, {
        value: value
    });
};
export var manageGroupRenameGroup = function (value, oldValue) {
    amplitude.logEvent(MANAGE_GROUP_RENAME_GROUP, {
        value: value, oldValue: oldValue
    });
};
export var manageGroupAddUser = function (by, value) {
    amplitude.logEvent(MANAGE_GROUP_ADD_USER, {
        by: by, value: value
    });
};
export var manageGroupRemoveUser = function (by, value) {
    amplitude.logEvent(MANAGE_GROUP_REMOVE_USER, {
        by: by, value: value
    });
};
export var manageGroupModalClosed = function (by) {
    amplitude.logEvent(MANAGE_GROUP_MODAL_CLOSED, {
        by: constantCase(by)
    });
};
export var manageRoleAddRole = function (by, value) {
    amplitude.logEvent(MANAGE_ROLE_ADD_ROLE, {
        by: constantCase(by),
        value: value
    });
};
export var manageRoleRenameRole = function (value, oldValue) {
    amplitude.logEvent(MANAGE_ROLE_RENAME_ROLE, {
        value: value,
        oldValue: oldValue
    });
};
export var manageRoleDeleteRole = function (value) {
    amplitude.logEvent(MANAGE_ROLE_DELETE_ROLE, {
        value: value,
    });
};
export var manageRoleChangePermission = function (by, value) {
    amplitude.logEvent(MANAGE_ROLE_CHANGE_PERMISSION, {
        by: constantCase(by),
        value: value
    });
};
export var manageRoleAddUser = function (by, value) {
    amplitude.logEvent(MANAGE_ROLE_ADD_USER, {
        by: by,
        value: value
    });
};
export var manageRoleRemoveUser = function (by, value) {
    amplitude.logEvent(MANAGE_ROLE_REMOVE_USER, {
        by: by,
        value: value
    });
};
export var manageRoleModalClosed = function (by) {
    amplitude.logEvent(MANAGE_ROLE_MODAL_CLOSED, {
        by: constantCase(by)
    });
};
export var systemSettingsUpdate = function (by, value) {
    amplitude.logEvent(SYSTEM_SETTINGS_UPDATE, {
        by: constantCase(by),
        value: value
    });
};
export var userListSort = function (by, value) {
    amplitude.logEvent(USER_LIST_SORT, {
        by: constantCase(by),
        value: value
    });
};
export var userListFilter = function (by, value) {
    amplitude.logEvent(USER_LIST_FILTER, {
        by: constantCase(by),
        value: value
    });
};
export var userListCustomize = function (action, value) {
    amplitude.logEvent(USER_LIST_CUSTOMIZE, {
        action: constantCase(action),
        value: value
    });
};
export var userListSearch = function (by, value) {
    amplitude.logEvent(USER_LIST_SEARCH, {
        by: constantCase(by),
        value: value
    });
};
export var userListStatusChange = function (by, value, oldValue) {
    amplitude.logEvent(USER_LIST_STATUS_CHANGE, {
        by: constantCase(by),
        value: value,
        oldValue: oldValue
    });
};
export var userListRoleChange = function (value, oldValue) {
    amplitude.logEvent(USER_LIST_ROLE_CHANGE, {
        value: value,
        oldValue: oldValue
    });
};
export var userListExport = function () {
    amplitude.logEvent(USER_LIST_EXPORT, {});
};
export var userListUpdateUser = function (by, oldValue, value) {
    amplitude.logEvent(USER_LIST_UPDATE_USER, {
        by: constantCase(by),
        oldValue: oldValue,
        value: value
    });
};
export var userListManageRolePermissions = function () {
    amplitude.logEvent(USER_LIST_MANAGE_ROLE_PERMISSIONS, {});
};
export var userListOnclickUsername = function () {
    amplitude.logEvent(USER_LIST_ONCLICK_USERNAME, {});
};
//# sourceMappingURL=amplitude-events.js.map